import { SolanaProviderOptions } from '@lifi/sdk'
import {
  BaseSignerWalletAdapter,
  TransactionOrVersionedTransaction,
} from '@solana/wallet-adapter-base'
import { PublicKey } from '@solana/web3.js'
import { signSolMessage } from '../../handlers/walletActions/wallet'
import { Wallet } from '../../providers/WalletProvider'

class SolanaWallet extends BaseSignerWalletAdapter {
  publicKey: PublicKey
  principalId: string

  name = '' as any
  url = ''
  icon = ''
  readyState = '' as any
  connecting = false
  supportedTransactionVersions = new Set([0 as const])

  constructor(wallet: Wallet) {
    super()

    this.publicKey = new PublicKey(wallet.solAddress!)
    this.principalId = wallet.principalId
  }

  async signTransaction<
    T extends TransactionOrVersionedTransaction<this['supportedTransactionVersions']>,
  >(transaction: T) {
    if ('message' in transaction) {
      const signatureAddresses = transaction.message.staticAccountKeys.map((k) => k.toString())
      const signatureIndex = signatureAddresses.indexOf(this.publicKey.toString())
      const signature = await signSolMessage(this.principalId, [...transaction.message.serialize()])
      transaction.signatures[signatureIndex] = Uint8Array.from(signature)

      return transaction
    } else {
      throw new Error('Unsupported transaction version')
    }
  }

  async connect() {
    throw new Error('connect is not implemented')
  }

  async disconnect() {
    throw new Error('disconnect is not implemented')
  }
}

export const getSolanaProviderOptions = (wallet: Wallet): SolanaProviderOptions => ({
  getWalletAdapter: async () => new SolanaWallet(wallet),
})
